import React from "react";
import { Col, Row } from "react-bootstrap";
import ButtonCard from '../../Helpers/Buttons/ButtonCard';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../sessionStorage';

import './HeroImage.scss';

export function HeroImage() {
  let heroImageUrl;
  let heroImageUrlMobile;
  let heroImageUrlTablet;
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  if (accountObj && accountObj.account && accountObj.account.heroImageUrl && !accountObj.accountOverrides) {
    heroImageUrl = accountObj.account.heroImageUrl;
  } else if (accountObj && accountObj.accountOverrides && accountObj.accountOverrides[0].homeHeroImageUrl) {
    heroImageUrl = accountObj.accountOverrides[0].homeHeroImageUrl;
  } else {
    heroImageUrl = '/home/hero-image.png';
  }

  if (accountObj && accountObj.account && accountObj.account.heroImageMobileUrl && !accountObj.accountOverrides) {
    heroImageUrlMobile = accountObj.account.heroImageMobileUrl
  } else if (accountObj && accountObj.accountOverrides && accountObj.accountOverrides[0].homeHeroImageMobileUrl) {
    heroImageUrlMobile = accountObj.accountOverrides[0].homeHeroImageMobileUrl;
  } else {
    heroImageUrlMobile = heroImageUrl;
  }

  if (accountObj && accountObj.account && accountObj.account.heroImageTabletUrl && !accountObj.accountOverrides) {
    heroImageUrlTablet = accountObj.account.heroImageTabletUrl
  } else if (accountObj && accountObj.accountOverrides && accountObj.accountOverrides[0].homeHeroImageTabletUrl) {
    heroImageUrlTablet = accountObj.accountOverrides[0].homeHeroImageTabletUrl;
  } else {
    heroImageUrlTablet = heroImageUrl;
  }

  const getRowSize = (count) => {

    // For Count 7 and 8
    if (count === 7 || count === 8) {
      return "750";
    }
    // For Count 1 to 5
    else if (count < 6) {
      return "1120";
    }

    const countForSix = Math.floor(count / 6);
    const countForFive = Math.floor(count / 5);

    if (((countForSix * 6) - count) === 0) // For 6,12,18,24,....
      {return "1120";}
    else if (((countForFive * 5) - count) === 0) // For 10,15,20,25,30,.....
      {return "930";}
    else if (((countForSix + 1) * 6) - count < ((countForFive + 1) * 5) - count) // For diaplay column 5 or 6
      {return "1120";}
    else
      {return "930";}

  }

  const cardMaxWidth = `${getRowSize(accountObj.accountProducts.length)}px`;

  const heroStyles = {
    '--hero-url-mobile': `url(${heroImageUrlMobile})`,
    '--hero-url-tablet': `url(${heroImageUrlTablet})`,
    '--hero-url-desktop': `url(${heroImageUrl})`,
    '--card-max-width': cardMaxWidth,
  };

  const cards = accountObj.accountProducts.map((content, index) => <ButtonCard key={index} id={index} name={content.displayName} subtitle={content.productSubtitle} target={content.openInNewTab ? "_blank" : "_self"} icon={content.productIconPath} href={content.productLink} />);
  return (
    <React.Fragment>
      <Row className={`home-hero-image justify-content-center`} style={heroStyles}>
       <Col className="content d-flex flex-column w-100">
          <Row className="header d-flex align-items-center h-100">
            <div className="header-text px-0">
              <h1 className="upper-text">Insurance Simplified</h1>
              <h2 className="lower-text">Get covered today.</h2>
            </div>
          </Row>
        </Col>
      </Row>
      <Row id="product-tiles" className="d-block product-mobile">
        <h3 className="text-center justify-content-center product-desktop">Select a product to get your quote</h3>
        <Row className={`product-desktop card-size justify-content-center`} style={heroStyles}>
          {cards.map((obj, index) => <Col className={`carrier mt-2`} xs="auto" md="auto" key={index}>
            {obj}
          </Col>)}
        </Row>
      </Row>
    </React.Fragment>
  );
}
